import {Component} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {AgentService} from '../service/agent.service';
import {LeadService} from '../service/lead.service';
import {AgentName} from '../model/agent-name.model';
import {retry} from 'rxjs/operators';
import {IframeNotificationService} from '../service/iframe-notification.service';

@Component({
  selector: 'app-transition',
  templateUrl: './transition.component.html',
  styleUrls: ['./transition.component.scss']
})
export class TransitionComponent {

  providerAgentId: string;
  preferredAgentId: string;
  preferredAgentName: string;
  providerAgentName: string;
  leadSource: string;

  isMilesAndMoreCustomer: boolean;
  milesAndMoreServiceNumber: string;

  utmSource: string;
  displayAddress: boolean;

  displayCustomerAddress: boolean;
  enableDocuments: boolean;

  preferredAgent: AgentName;

  formData: FormData;
  formState: TransitionState = TransitionState.NEW;

  formIsValid: boolean = false;

  files: File[] = [];

  constructor(private route: ActivatedRoute,
              private agentService: AgentService,
              private leadService: LeadService,
              private iframeNotificationService: IframeNotificationService) {

    this.route.queryParamMap.subscribe(params => {
      this.preferredAgentId = params.get('preferredAgent');
      this.providerAgentId = params.get('providerAgent');
      this.leadSource = params.get('leadSource');
      this.preferredAgentName = params.get('preferredAgentName');
      this.providerAgentName = params.get('providerAgentName');
      this.utmSource = params.get('utm_source');
      this.displayAddress = params.get('enableAddress') === 'true';
      this.displayCustomerAddress = params.get('enableCustomerAddress') === 'true';
      this.enableDocuments = params.get('enableDocuments') === 'true';
      this.isMilesAndMoreCustomer = params.get('tippgeberpartnerid') === 'OOB05';
      this.milesAndMoreServiceNumber = params.get('milesAndMoreServiceNumber');

      if (!this.leadSource) {
        this.formState = TransitionState.CONFIG_ERROR;
      }

      agentService.getAgentByOfficeAllocation(this.preferredAgentId).pipe(retry(5)).subscribe(
        agent => this.preferredAgent = agent
      );
    });
  }

  initFormData() {
    this.formData.append('referer', window.location.href);
    this.formData.append('providerAgentId', this.providerAgentId);
    this.formData.append('preferredAgentId', this.preferredAgentId);
    this.files.forEach((file, index) => {
      this.formData.append('file' + index, file);
    });
  }

  onSubmit(formEvent) {
    this.formData = new FormData(formEvent.target);
    this.initFormData();

    if (!this.formIsValid) {
      this.formState = TransitionState.SUBMIT_FAILED;
    } else {
      this.createLead();
    }
  }

  createLead() {
    this.formState = TransitionState.SENDING;
    this.leadService.postLead(this.leadSource, this.formData).subscribe(
      success => {
        this.formState = TransitionState.SUCCESS;
        this.iframeNotificationService.sendHeightEvent();
      },
           error => this.formState = TransitionState.SERVER_ERROR);
  }

}


export enum TransitionState {
  NEW = 'NEW',
  SENDING = 'SENDING', // form is currently being sent
  CONFIG_ERROR = 'CONFIG_ERROR', // No leadSourceId found. form has no receiver
  SUBMIT_FAILED = 'SUBMIT_FAILED', // user tried to submit but form fields were invalid or server responded with error
  SERVER_ERROR = 'SERVER_ERROR', // we sent the lead but the server could not process it
  SUCCESS = 'SUCCESS' // form was successfully submitted
}


